import { TABLET_LOWER_THRESHOLD, DESKTOP_LOWER_THRESHOLD } from 'site-constants';

import useMedia from '@hooks/use-media';

type ScreenSizeCategory = 'small' | 'medium' | 'large';

/**
 * Returns the categorised width of the page, i.e. whether it is small, medium or large
 */
export default function useScreenCategory(): [isSmall: boolean, isMedium: boolean, isLarge: boolean] {
  const screenSizeCategory = useMedia<ScreenSizeCategory>(
    // Media queries
    [`(min-width: ${DESKTOP_LOWER_THRESHOLD}px)`, `(min-width: ${TABLET_LOWER_THRESHOLD}px)`],
    // Column counts (relates to above media queries by array index)
    ['large', 'medium'],
    // Default column count
    'small'
  );

  const isLarge = screenSizeCategory === 'large';
  const isMedium = screenSizeCategory === 'medium';
  const isSmall = screenSizeCategory === 'small';

  return [isSmall, isMedium, isLarge];
}
